import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6fc61fac"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "advertise"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "img_box"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_image = _resolveComponent("my-image");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "banner_item",
      key: index,
      onClick: $event => $setup.toDetails(item)
    }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_my_image, {
      url: item.url
    }, null, 8, ["url"])]), _createElementVNode("p", null, _toDisplayString(item.title), 1)], 8, _hoisted_2);
  }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList1, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      onClick: $event => $setup.toDetails(item),
      key: index
    }, _toDisplayString(item.title), 9, _hoisted_5);
  }), 128))])], 64);
}